import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {FreeSpinsModule} from '@gongxigames/framework/slot/modules/freespins/FreeSpinsModule';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow/FlowModuleEvents';

export class FreeSpinsBasicState extends ModuleState<null, FreeSpinsModule> {
    public onEnterState(): void {
    }

    public onLeaveState(): void {
    }

    protected setupEvents(): void {
        this.setEventHandler(FlowModuleEvents.FREESPINS_WIN, this.onFreeSpinsWin.bind(this));
        this.setEventHandler(FlowModuleEvents.FREESPINS_RESTORED, this.onFreeSpinsRestored.bind(this));
    }

    protected onFreeSpinsRestored(): void {
        this.module.soundPlayer.playMusic('freespin');
        this.module.gotoState(FreeSpinsModule.IN_PROGRESS_STATE);
    }

    protected onFreeSpinsWin(): void {
        this.module.gotoState(FreeSpinsModule.INTRO_STATE);
    }
}
